export default function CheckboxGroup({ label, name, options = [], values = [], onChange, layout = "grid" }) {
  function toggle(value) {
    const next = values.includes(value)
      ? values.filter((item) => item !== value)
      : [...values, value];
    onChange({ target: { name, value: next } });
  }

  return (
    <fieldset className="field" style={{ border: 0, padding: 0 }}>
      {label ? <legend className="field-label">{label}</legend> : null}
      <div className={`checkbox-group${layout === "grid" ? " checkbox-group--grid" : ""}`}>
        {options.map((option) => (
          <label key={option.value} className="checkbox-item">
            <input
              type="checkbox"
              name={name}
              checked={values.includes(option.value)}
              onChange={() => toggle(option.value)}
            />
            <span>{option.label}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
